import styled from 'styled-components';
import { getColor } from '@karma/components/colors';

export const InfoPageDarkText = styled.span`
  color: ${getColor('primary1')};
  font-weight: bold;
`;
